import * as graphql from 'generated/graphql';
import { dateTimeFieldPolicy } from 'modules/common/layer01/apolloClient/cache/typePolicies/fieldPolicies';
import { ITypeSpecificPolicy } from './shared';



export const DeepDiveTopic: ITypeSpecificPolicy<graphql.DeepDiveTopic> = {
  fields: {
    updatedTimestamp: dateTimeFieldPolicy()
  }
};
